import { render, staticRenderFns } from "./GameReaction.vue?vue&type=template&id=f4259ce4&"
import script from "./GameReaction.vue?vue&type=script&lang=js&"
export * from "./GameReaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports